import {ArchiveIcon} from '@primer/octicons-react'
import {Spinner} from '@primer/react'
import {memo} from 'react'

import {Blankslate} from '../../../components/common/blankslate'
import styles from './archive-empty-states.module.css'

export const NoArchivedItems = memo(function NoArchivedItemsComponent() {
  return (
    <Blankslate className={styles.Blankslate}>
      <ArchiveIcon size={30} className={styles.Octicon} />
      <h2>There aren&apos;t any archived items</h2>
      <p className={styles.Octicon}>Archive items from a project view and they&apos;ll be shown here.</p>
    </Blankslate>
  )
})
export const NoFilteredItems = memo(function NoFilteredItemsComponent() {
  return (
    <Blankslate className={styles.Blankslate}>
      <ArchiveIcon size={30} className={styles.Octicon} />
      <h2>No results matched your filter</h2>
    </Blankslate>
  )
})
export const Loader = memo(function LoaderComponent() {
  return (
    <Blankslate className={styles.Blankslate}>
      <Spinner />
    </Blankslate>
  )
})
